import { LOAD_SHOGUN_DATA } from '../constants'

const shogun = (state={}, action) => {
  switch(action.type) {
    case LOAD_SHOGUN_DATA:
      return {...action.data}
    default:
      return state;
  }
}

export default shogun


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/reducers/shogunReducer.js